import React from 'react';
import { notComparedReason } from '../../../../../../constants';

// One not-compared leader, straight from the API. Memoized on `leader`, which
// keeps its identity across pages (the reducer appends), so loading more
// mounts only the new rows and the reason is worked out once per row.
const NotComparedRow = ({ leader }) => (
    <div className='trend-table__row'>
        <div className='trend-table__person'>
            <span className='trend-table__person-name'>{leader.fullName || leader.selfEmail}</span>
            <span className='trend-table__person-email'>{leader.selfEmail}</span>
        </div>
        <div className='trend-notcompared__reason'>{notComparedReason(leader)}</div>
    </div>
);

export default React.memo(NotComparedRow);
